<template>
  <div>
    <v-text-field
      class="input-exam"
      v-model="selectedTitle"
      color="secondary"
      :rules="rules"
      dense
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      rules: [
        value => this.validateLength(value),
      ],
    }
  },
  computed: {
    ...mapGetters([
      'selectedSubjectIsKokugo',
    ]),
    selectedTitle: {
      get() {
        return this.$store.state.sheet.title
      },
      set(value) {
        this.$store.commit('sheet/setTitle', { title: value })
        this.$emit('changeTitle')
      }
    }
  },
  methods: {
    validateLength(value) {
      if (!value) return true; // 空の値は通過させる
      const maxLength = this.selectedSubjectIsKokugo ? 30 : 37;
      return value.length <= maxLength || `全角${maxLength}文字以内で入力してください`;
    }
  }
}
</script>

<style lang="stylus" scoped>
.select-exam
  margin-top 30px
  width 300px
.input-exam
  width 300px
</style>
